import * as React from 'react';
import { ListGroupItem } from 'react-bootstrap';
import { bind } from '../../utils/decorators';

import { IQmDokument } from '../../models/ApiTypes';

interface IQmListeProps {
  expanded: boolean;
  befugnis: string;
  dokumente: Array<IQmDokument>;
  handleEintragClick: (befugnis: string, dateiname: string) => void;
}

export class QmListe extends React.Component<IQmListeProps, {}> {

  @bind handleDokumentClick(dokument: IQmDokument) {
    this.props.handleEintragClick(this.props.befugnis, dokument.dateiname);
  }

  render() {
    if (this.props.dokumente.length === 0) {
      return null;
    }
    return (
      <div>
        <h3>{this.props.befugnis}</h3>
        {this.props.dokumente.map((dokument, index) => <QmDokuListItem key={index} qmDokument={dokument} handleDokumentClick={this.handleDokumentClick} />)}
      </div>
    );
  }
}


interface IAuftragListItemProps {
  qmDokument: IQmDokument;
  handleDokumentClick: (dokument: IQmDokument) => void;
}

class QmDokuListItem extends React.Component<IAuftragListItemProps, {}> {

  render() {
    return (
      <ListGroupItem
        className={'qm-listeneintrag'}
        onClick={() => this.props.handleDokumentClick(this.props.qmDokument)}
      >
        <span className="text-primary">
          {this.props.qmDokument.titel}
        </span>
      </ListGroupItem>
    );
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/user/QmListe.tsx